export const logCurrent = (object: object) => {
  console.log(JSON.parse(JSON.stringify(object)));
};
